module.exports = __webpack_public_path__ + "01_long_gold.32d0a751.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_long_gold.png
// module id = +G//
// module chunks = 0